import { Grid, Box, CardMedia, CardContent, Typography } from '@mui/material';

import { StyledCard } from './styles.js';
import { mockData } from './mockData.js';
import DefaultWrapper from 'shared-components/DefaultWrapper';
import { Title } from 'components/MyCareNetwork';

export const MyData = () => {
  const crumbs = [{ title: 'My data making a difference', isActive: true }];

  return (
    <DefaultWrapper
      crumbs={crumbs}
      showHeader={false}
      margin={{ xs: '15px', md: '20px 40px 50px 40px' }}>
      <Box
        sx={{
          maxWidth : '1300px',
          marginX  : 'auto',
        }}>
        <Title>My data making a difference</Title>
        <Box
          display='flex'
          justifyContent='space-between'
          gap='20px'
          flexDirection='column'
          margin='20px 0 50px 0'>
          <Typography
            fontFamily='Montserrat'>
            As a member of the ADPKD Registry, the only patient-powered research
            network for polycystic kidney disease in the U.S., you are making
            history. Your participation is changing the role of people affected
            by ADPKD and enabling researchers to study the topics that matter
            most to people affected by the disease.
          </Typography>
          <Typography
            fontFamily='Montserrat'>
            See below for participant newsletters and other items we’ve created
            to share with you some details of what we’re learning. For more
            resources, community support and updates on PKD research, visit the
            <a
              style={{ marginLeft: 6 }}
              href='https://pkdcure.org/'
              target='_blank'
              rel='noreferrer'>
              PKD Foundation website
            </a>
            .
          </Typography>
        </Box>

        <Grid
          container spacing={2} marginBottom='50px'>
          {mockData.map((item) => (
            <Grid
              key={item.id} item md={3} sm={6}>
              <a
                href={item.pdfLink} target='_blank' rel='noreferrer'>
                <StyledCard>
                  <Box>
                    <CardMedia
                      component='img'
                      image={item.image}
                      alt={item.title}
                      height='149'
                      style={{ objectFit: item.fit ?? 'cover' }}
                    />
                    <CardContent>
                      <Typography
                        gutterBottom
                        variant='h5'
                        component='div'
                        fontFamily='Montserrat'>
                        {item.title}
                      </Typography>
                      <Typography
                        variant='body2'
                        fontFamily='Montserrat'
                        lineHeight='1.5rem'>
                        {item.description}
                      </Typography>
                    </CardContent>
                  </Box>
                </StyledCard>
              </a>
            </Grid>
          ))}
        </Grid>
      </Box>
    </DefaultWrapper>
  );
};
